const TRAILING_SLASH_REGEX = /\/$/;

export function formatUrl(url: string) {
  const { hostname, pathname } = new URL(url, process.env.APP_URL);
  return hostname + pathname.replace(TRAILING_SLASH_REGEX, "");
}

export function players(playersMin?: number, playersMax?: number) {
  if (!(playersMin || playersMax)) {
    return "";
  }
  if (playersMin === playersMax) {
    return (playersMin as number).toString();
  }
  if (!playersMin) {
    return `Up to ${playersMax}`;
  }
  if (!playersMax) {
    return `${playersMin}+`;
  }
  return `${playersMin}-${playersMax}`;
}

export function toSentenceCase(str: string) {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}
